import TileWrapper from '../TileWrapper'
import { Link } from 'react-router-dom'
import { useTeam } from 'app/frontend/base/config/context/team'

import { useOverviewData } from 'app/frontend/base/config/queries'
import UpcomingEvent from 'app/frontend/base/components/UpcomingEvent'
import DetailedEvent from 'app/frontend/base/components/DetailedEvent'
import { useTile } from '../../context'
import LinkButton from '@/components/ui/link-button'
import Card from 'app/frontend/base/components/Card'

const UpcomingEventsTile = () => {
  const { tile } = useTile()
  const { team } = useTeam()
  const { data: overviewData } = useOverviewData(team.id)
  const events = overviewData?.upcomingEvents || []

  if (events.length === 0) {
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No upcoming events scheduled.</p>
      </TileWrapper>
    )
  }

  const amount = Math.abs(tile.config?.amount ?? 5)

  return (
    <TileWrapper
      cta={
        <LinkButton to={`${team.path}/events`} size='xs'>
          View all
        </LinkButton>
      }
    >
      <div className='space-y-2'>
        {events.slice(0, amount).map((event) => (
          <Card key={event.id} className=''>
            <Link to={`${team.path}/events/${event.id}`} className='group'>
              {tile.position === 'main' ? (
                <DetailedEvent eventReference={event} />
              ) : null}

              <UpcomingEvent
                className={tile.position === 'main' ? 'sm:hidden' : ''}
                eventReference={event}
              />
            </Link>
          </Card>
        ))}
      </div>
    </TileWrapper>
  )
}

export default UpcomingEventsTile
